import Swal from "sweetalert2";

/**
 * Muestra un modal de carga bloqueante
 * @param {string} titulo - Título del modal
 */
export const modalLoading = (titulo) => {
    Swal.fire({
        title: titulo,
        text: "Espere un momento ...",
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
};

/**
 * Cierra el modal abierto con modalLoading
 */
export const closeModalLoading = () => {
    Swal.close();
};
